import React, { useState } from "react";
import { Button, Col, Form, Input, Modal, Row, Select, Switch } from "antd";
import { EditFilled } from "@ant-design/icons";
import axios from "axios";
import { baseURL } from "../service/ApiService";

const { TextArea } = Input;

const GptPromptAddModal = ({
                               buttonName = "Add Prompt",
                               title = "Add New Prompt",
                               models,
                               callback,               // callback after successful POST
                           }) => {
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => {
        form.resetFields();   // clear out any old values
        setVisible(true);
    };

    const handleOk = () => {
        form
            .validateFields()
            .then((values) => {
                console.log(values);
                const payload = {
                    name: values.name.trim(),
                    englishPrompt: values.englishPrompt.trim(),
                    gptModelId: values.model,
                    enableJson: values.enableJson,
                    jsonSchema: values.enableJson ? values.jsonSchema : "{}",
                };

                axios
                    .post(`${baseURL}/api/prompt`, payload)
                    .then(() => {
                        callback?.();
                        setVisible(false);
                    })
                    .catch((err) => {
                        console.error("Failed to add prompt:", err);
                    });
            })
            .catch((err) => {
                console.error("Validation Failed:", err);
            });
    };

    return (
        <>
            <Button
                type="primary"
                onClick={showModal}
                icon={<EditFilled />}
            >
                {buttonName}
            </Button>

            <Modal
                title={title}
                width={800}
                centered
                destroyOnClose
                visible={visible}
                onOk={handleOk}
                onCancel={() => setVisible(false)}
                okText="Create"
            >
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={{
                        enableJson: false,
                    }}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[{ required: true, message: "Please enter the prompt name" }]}
                            >
                                <Input placeholder="Enter a descriptive name" />
                            </Form.Item>

                            <Form.Item
                                label="GPT Model"
                                name="model"
                                rules={[{ required: true, message: "Please select a GPT model" }]}
                            >
                                <Select placeholder="Choose a model">
                                    {models.map((m) => (
                                        <Select.Option key={m.id} value={m.id}>
                                            {m.modelName}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item
                                label="English Prompt"
                                name="englishPrompt"
                                rules={[{ required: true, message: "Please enter the English prompt" }]}
                            >
                                <TextArea rows={6} placeholder="Your prompt here" />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="Enable JSON Schema"
                                name="enableJson"
                                valuePropName="checked"
                            >
                                <Switch />
                            </Form.Item>

                            <Form.Item
                                label="JSON Schema"
                                name="jsonSchema"
                                dependencies={['enableJson']}
                                rules={[{ required: true, message: "Please provide a JSON schema" }]}
                                hidden={!form.getFieldValue('enableJson')}
                            >
                                <TextArea autoSize={{ minRows: 4, maxRows: 12 }} />
                            </Form.Item>

                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};

export default GptPromptAddModal;
